import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { exchangeSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      const result = await exchangeSession(match[1]);
      // Clear the hash
      window.history.replaceState(null, "", window.location.pathname);
      if (result.ok) {
        toast.success(`Witaj ${result.user.name || result.user.email}! ✨`);
        if (result.user.role === "admin") {
          navigate("/admin", { replace: true, state: { user: result.user } });
        } else {
          navigate("/", { replace: true, state: { user: result.user } });
        }
      } else {
        toast.error("Nie udało się zalogować przez Google");
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, exchangeSession, navigate]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#F4FAFF]" data-testid="auth-callback">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="text-center"
      >
        <Loader2 className="mx-auto text-[#60A5FA] animate-spin" size={44} />
        <p className="mt-4 font-display text-xl text-[#051937]">
          Duszek loguje Cię do środka...
        </p>
      </motion.div>
    </div>
  );
}
